export default __webpack_public_path__ + "static/media/review-icon.a2aa8e08.svg";